import AddNewParkingModalView from "./addNewParkingModal.html";


angular.module("events")
    .controller("EventsParkingsListCtrl", ['event', 'LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$stateParams', '$state', '$http', '$window', 'uiGridConstants', 'eventService','generateDocumentService',
        function (event, LoginService, $rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter, $translate, $stateParams, $state, $http, $window, uiGridConstants, eventService, generateDocumentService) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENTS_PARKINGS_WRITE") ;
            if(!Array.isArray($scope.$parent.menusItems)) {
                $state.go("events.edit", { id: $stateParams.id });
            } else {
                let results = $scope.$parent.menusItems.filter(m => m.id === parseInt($stateParams.menu_item_id, 10));
                if(results.length > 0) {
                    $scope.allowWrite &&= results[0].editable;
                } else {
                    $scope.allowWrite = false;
                }
            }

            $rootScope.title = $filter('translate')('events.title') + " - " + $filter('translate')('events.parkings.parkings');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('events.title'), url: "events.list" },
                { title: $filter('translate')('events.title'), url: "events.list" },
                { title: $filter('translate')('events.parkings.parkings') }
            ];

            $scope.event = event;

            $rootScope.breadcrumb = [
                { title: $filter('translate')('events.title'), url: "events.list" },
                { title: $scope.event.name, url: "events.edit({ id: " + $scope.event.id + " })" },
                { title: $filter('translate')('events.parkings.parkings') }
            ];
            $rootScope.title = $scope.event.name + " - " + $filter('translate')('events.parkings.parkings');

            $scope.gridOptionEventParkings = {
                pdfTitle: $filter('translate')('events.parkings.pdf_title'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                //gridMenuShowHideColumns: false,
                rowTemplate: '<div ng-dblclick="grid.appScope.editParking(row.entity.id)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                enableSorting: true,
                paginationPageSizes: [20, 50, 100],
                paginationPageSize: 20,
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                  { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                  { name: 'name', field: 'name', displayName: $filter('translate')('events.parkings.name'), enableFiltering: true, enableHiding: false },
                  {
                      name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                          { title: $filter('translate')('calendars.print'), action: 'ng-click="grid.appScope.print(row.entity.id)"', cssIconClass: "fa fa-file" },
                          { title: $filter('translate')('events.parkings.button_edit'), action: 'ng-click="grid.appScope.editParking(row.entity.id)"', cssIconClass: "fa fa-edit" },
                          { title: $filter('translate')('events.parkings.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                      ], { cssClass: "pull-right" })
                  },
                ],
                getData: function (options) {
                    options.event_id = $stateParams.id;
                    return Restangular.all('EventsParkings').getList(options);
                }
            };

            $scope.editParking = function (id) {
                var options = {
                    event_id: $scope.event.id,
                    parking_id: id
                };
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: AddNewParkingModalView,
                    controller: "addParkingModalCtrl",
                    size: 'lg',
                    resolve: {

                        options: function () {
                            return options;
                        }
                    }

                });

                //Retorno de los datos desde el modal.
                $modalInstance.result.then(function (parking) {
                    if (angular.isDefined(id)) {
                        parking.put().then(function (result) {
                            if (angular.isDefined(result.id)) {
                                toastr.success($filter('translate')('events.parkings.edit_success'));
                            }
                            $scope.gridOptionEventParkings.loadData(false);
                        });
                    } else {
                        Restangular.all('EventsParkings').post(parking).then(function (result) {
                            if (angular.isDefined(result.id)) {
                                toastr.success($filter('translate')('events.parkings.create_success'));
                            }
                            $scope.gridOptionEventParkings.loadData(false);
                        });
                    }

                });
            }

            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                modalService.confirm({
                    title: $filter('translate')('events.parkings.button_delete'),
                    message: $filter('translate')('events.parkings.delete_message') + " " + name + "?",
                    onAccept: function () {
                        Restangular.one('EventsParkings', id).remove().then(function () {
                            $scope.gridOptionEventParkings.gridApi.core.raise.itemChanged($scope);
                            toastr.success($filter('translate')('events.parkings.delete_success'));
                        });
                    }
                });

            };

            $scope.print = function (parkingId) {
                var params = {
                    entity_type: "events",
                    entity_type_id: $stateParams.id,
                    event_guests_id: 0,
                    documents: {
                        codes: ["GUEST_PARKING"]
                    }
                };
                generateDocumentService.documentNew({
                    params: params,
                    onAccept: function (data) {
                        angular.forEach(data, function (item) {
                            $http({
                                method: 'post',
                                url: (window as any).CONFIG.api_url + 'documentgenerator/Generate',
                                params: { document_id: item.document_id, event_id: params.entity_type_id, parking_id: parkingId, outputType: 'pdf' }

                            }).then(function (result, status, headers, config) {
                                var url = (window as any).CONFIG.api_url + 'documentgenerator/download/' + result.data;
                                window.open(url, '_blank');
                            });
                        })

                    }
                });
            }

        }])

.controller("addParkingModalCtrl", ['options', '$scope', '$uibModalInstance', 'LoginService', 'Restangular', function (options, $scope, $uibModalInstance, LoginService, Restangular) {
    $scope.allowWrite = LoginService.permissionExist("EVENTS_PARKINGS_WRITE");

    $scope.parking = {
        id: options.parking_id,
        event_id: options.event_id,
        FK_events_parkings_images: {}
    };

    if (angular.isDefined(options.parking_id)) {
        Restangular.one('EventsParkings', options.parking_id).get().then(function (parking) {
            $scope.parking = parking;
            if (angular.isUndefined($scope.parking.FK_events_parkings_images) || $scope.parking.FK_events_parkings_images == null)
                $scope.parking.FK_events_parkings_images = {};
        });
    }

    $scope.addFile = function (flowFile) {
        var fileReader = new FileReader();
        fileReader.onload = function (event) {
            var uri = event.target.result;
            $scope.$apply(function () {
                $scope.parking.image = uri;
                $scope.parking.FK_events_parkings_images.image = uri;
            });
        };
        fileReader.readAsDataURL(flowFile.file);
    };

    $scope.saveParking = function () {
        $uibModalInstance.close($scope.parking);
    };


    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

}])
;
